import './css/Footer.css';
import { translateFooter } from '../../data/translateFooter';

function Footer({language, setLanguage}) {

    const select = translateFooter[language].footer;

    return (
        <footer className="footer-section" id="contact">
            <div className="footer-container">
                
                {/* --- CALL TO ACTION --- */}
                <div className="footer-cta">
                    <div className="cta-text">
                        <h2>{select.titulo}</h2>
                        <p>{select.subtitulo}</p>
                    </div>
                    
                    <div className="cta-buttons">
                        <a href="mailto:tiagolucas.dev@gmail.com" className="btn-email">
                            {select.email}
                        </a>
                        <a href="https://linkedin.com/in/tiagolucasoo" target="_blank" rel="noreferrer" className="btn-linkedin">
                            {select.linkedin}
                        </a>
                    </div>
                </div>

                {/* --- BOTTOM ROW --- */}
                <div className="footer-bottom">
                    
                    {/* Logo (Usando o seu padrão do cabeçalho) */}
                    <div className="footer-logo">
                        <span className="logo-item1">{"</>"}</span>
                        <span className="logo-item2">{"tiago"}</span>
                        <span className="logo-item3">{"lucas"}</span>
                        <span className="logo-item4">•</span>
                    </div>

                    {/* Copyright */}
                    <div className="footer-copy">
                        <p>{select.copyright}</p>
                        {/* <p className="made-with">
                            Desenvolvido com <span className="heart">♥</span> em React & CSS Puro.
                        </p> */}
                    </div>
                    
                </div>
            </div>
        </footer>
    );
}

export default Footer;